import { MySection } from '@/components/custom/my-section';
import { OrderItemsEditor } from '@/components/orders/OrderItemsEditor';
import { FormField, FormItem, FormMessage } from '@/components/ui/form';
import { OrderCreateFormValues } from '@/types/order-type';
import { UseFormReturn } from 'react-hook-form';

interface LineItemsSectionProps {
  form: UseFormReturn<OrderCreateFormValues>;
  watchItems: OrderCreateFormValues['items'];
  onItemsChange?: () => void;
}

export function LineItemsSection({ form, watchItems, onItemsChange }: LineItemsSectionProps) {
  const itemsValue = watchItems || [];
  const hideAllItems = itemsValue.length === 0 ? false : undefined;

  return (
    <MySection title="Line items">
      <FormField
        control={form.control}
        name="items"
        render={({ field }) => (
          <FormItem>
            <OrderItemsEditor
              value={field.value || []}
              onChange={(items) => {
                field.onChange(items);
                onItemsChange?.();
                form.trigger('items');
              }}
              hideAllItems={hideAllItems}
            />
            <FormMessage />
          </FormItem>
        )}
      />
    </MySection>
  );
}
